import React, { type ReactNode } from 'react';

import { Badge, Col, Form, Row, Typography } from 'antd';

import styles from './Field.module.css';

const { Text } = Typography;

export interface CommonCardField {
  label: string;
  value: any;
  editable?: boolean;
  visible?: boolean;
  hidden?: boolean;
}

export interface SimpleCardField extends CommonCardField {
  dataIndex?: never;
  input?: never;
  normalize?: never;
  valuePropName?: never;
  render?: React.ReactElement;
}

export interface EditableCardField extends CommonCardField {
  editable: boolean;
  dataIndex: string;
  input: ReactNode;
  normalize?: (value: any) => string;
  valuePropName?: string;
}

export type CardField = SimpleCardField | EditableCardField;

interface FieldProps {
  isEditing: boolean;
}

export const Field = (props: FieldProps & CardField) => {
  const { isEditing, label, value } = props;

  const formValue = () => {
    if (typeof value === 'boolean') {
      return value ? <Badge status="success" /> : <Badge status="error" />;
    }
    if (value && 'hidden' in props && props.hidden)
      return <Typography.Paragraph copyable={{ text: value }}>••••••••••••••••••</Typography.Paragraph>;
    return value || '—';
  };

  return (
    <Row className={styles.field}>
      <Col span={12}>
        <Text strong>{label}:</Text>
      </Col>
      <Col span={12}>
        {isEditing && 'editable' in props && props.editable && 'dataIndex' in props ? (
          <Form.Item
            name={props.dataIndex}
            style={{ margin: 0 }}
            normalize={props.normalize}
            className="wide"
            valuePropName={props.valuePropName}
          >
            {props.input}
          </Form.Item>
        ) : (
          <Text style={{ whiteSpace: 'pre-line' }}>{formValue()}</Text>
        )}
      </Col>
    </Row>
  );
};
